import { CandidateDTO } from "../../../models/recruiting/candidate/candidate-dto";
import { CandidateSTO } from "../../../models/recruiting/candidate/candidate-sto";
import { toastifyResponse } from "../../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../../base/base-api.service";

export class CandidateApiService extends BaseApiService<CandidateDTO, CandidateSTO> {
  constructor() {
    super({
      servicePath: "/Candidates",
      loadItemsPath: "/GetCandidates",
      saveItemsPath: "/SaveCandidates",
    });
  }
}

export const saveCandidate = async (position: CandidateSTO) => {
  const response = await new CandidateApiService().saveItems([position]);

  toastifyResponse(response);

  return response;
};
